import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const SimpleSpinner = props => {
  const classnames = classNames('ndx-SimpleSpinner-wrapper', {
    'is-Centered': props.isCentered
  });
  const inlineStyle = {width: props.size, height: props.size};
  if (props.isCentered) {
    inlineStyle.marginTop = -props.size / 2;
    inlineStyle.marginLeft = -props.size / 2;
  }
  return (
    <div className="ndx-SimpleSpinner" aria-busy>
      <div className={classnames} style={inlineStyle}>
        <div className="ndx-SimpleSpinner-component" />
      </div>
    </div>
  );
};
const propTypes = {
  isCentered: PropTypes.bool,
  size: PropTypes.number
};

SimpleSpinner.propTypes = propTypes;

SimpleSpinner.defaultProps = {
  isCentered: true,
  size: 48
};
export default SimpleSpinner;
